var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('quillEditor',{ref:"quill",attrs:{"value":_vm.value,"options":_vm.editorOption},on:{"input":($event) => _vm.$emit('input', $event)}}),_vm._v(" "),_c('UploadImage',{attrs:{"show":_vm.showUploadImgDialog,"dir":_vm.dir},on:{"cancel":_vm.cancelUploadImg,"confirm":_vm.getImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }